import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
	getReportingFrequencyList as getReportingFrequencyListApi,
	getReportingFrequencyListQuery as getReportingFrequencyListQueryApi,
	getReportingFrequency as getReportingFrequencyApi,
	addNewReportingFrequencyApi,
	updateReportingFrequencyApi,
	deleteReportingFrequencyApi,
	checkReportingFrequencyExistsApi,
} from '../../helpers/reporting_frequency/api_helper';

export const getReportingFrequencyList = createAsyncThunk(
	'reportingFrequency/getReportingFrequencyList',
	async () => {
		try {
			const response = await getReportingFrequencyListApi();
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener las frecuencias de reportabilidad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getReportingFrequencyListQuery = createAsyncThunk(
	'reportingFrequency/getReportingFrequencyListQuery',
	async params => {
		try {
			const response = getReportingFrequencyListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getReportingFrequency = createAsyncThunk(
	'reportingFrequency/getReportingFrequency',
	async reporting_frequency_id => {
		try {
			const response = await getReportingFrequencyApi(reporting_frequency_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener la frecuencia de reportabilidad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewReportingFrequency = createAsyncThunk(
	'reportingFrequency/addNewReportingFrequency',
	async reporting_frequency => {
		try {
			const response = await addNewReportingFrequencyApi(reporting_frequency);
			toast.success('Frecuencia de Reportabilidad agregada exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar la frecuencia de reportabilidad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateReportingFrequency = createAsyncThunk(
	'reportingFrequency/updateReportingFrequency',
	async reporting_frequency => {
		try {
			const response = await updateReportingFrequencyApi(reporting_frequency);
			toast.success('Frecuencia de Reportabilidad actualizada exitosamente.', {
				autoClose: 3000,
			});
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar la frecuencia de reportabilidad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteReportingFrequency = createAsyncThunk(
	'reportingFrequency/deleteReportingFrequency',
	async reporting_frequency => {
		try {
			await deleteReportingFrequencyApi(reporting_frequency._id);
			toast.success('Frecuencia de Reportabilidad eliminada exitosamente.', {
				autoClose: 3000,
			});
			return reporting_frequency;
		} catch (error) {
			toast.error('Error al eliminar la frecuencia de reportabilidad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkReportingFrequencyExists = createAsyncThunk(
	'reportingFrequency/checkReportingFrequencyExists',
	async name => {
		try {
			const response = await checkReportingFrequencyExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
